<template>
    <v-sheet tile class="">  
        <!--:Race="Race"-->
        <SectionCheckIn 
            v-if="Check.checkType == 'in'" 
            ref="sectionCheckIn"
            :Check="Check" 
            :Section="Section" 
            :runLimit="runLimit"
        />
        <SectionCheckOut 
            v-if="Check.checkType == 'out'" 
            ref="sectionCheckOut"
            :Check="Check" 
            :Section="Section" 
        />        
    </v-sheet>
</template>

<style scoped lang="scss">
</style>

<script>
import SectionCheckIn from "@/components/section-editor/SectionCheckIn.vue"
import SectionCheckOut from "@/components/section-editor/SectionCheckOut.vue"

export default {
    props:["Check","Section","runLimit"],
    components: {
        SectionCheckIn,
        SectionCheckOut,
    },
    methods:{
        setPenalties: function(){
            let app = this;
            if(app.Check.checkType == "in"){
                app.setInPenalties();
            } else {
                app.setOutPenalties();
            }
        },
        setInPenalties: function(){
            let app = this;
            let check = app.Check;
            check.penalties.map(function(penalty) {
                if(penalty.penaltyType == "early"){
                    app.PenaltiesInEarly = penalty;
                } else {
                    app.PenaltiesInLate = penalty;
                }
            });
        },
        setOutPenalties: function(){
            let app = this;
            let check = app.Check;
            check.penalties.map(function(penalty) {
                if(penalty.penaltyType == "early"){
                    //do nothing
                    //app.PenaltiesOutEarly = penalty;
                } else {
                    app.PenaltiesOutLate = penalty;
                }
            });
        }
    },
    data () {
        return {
            SectionCheckIn : [],
            SectionCheckOut : [],
        }
    },
	created: function() {
		this.setPenalties();
    }
}
</script>
